import React, { useState } from 'react';
import { Card } from 'primereact/card';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { useCertifiers } from '../hooks/useCertifiers';
import { useConfirmation } from '../../../common/hooks/useConfirmation';
import CertifierModal from '../components/CertifierModal';

const CertifiersPage = () => {
  const { certifiers, loading, error, addCertifier, editCertifier, removeCertifier } = useCertifiers();
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedCertifier, setSelectedCertifier] = useState(null);
  const { confirm } = useConfirmation();

  const openCreateModal = () => {
    setSelectedCertifier(null);
    setModalVisible(true);
  };

  const openEditModal = (certifier) => {
    setSelectedCertifier(certifier);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setSelectedCertifier(null);
  };

  const handleSave = async (formData) => {
    if (selectedCertifier) {
      await editCertifier(selectedCertifier.id, formData);
    } else {
      await addCertifier(formData);
    }
  };

  const handleDelete = (certifier) => {
    confirm({
      message: `¿Estás seguro de que quieres eliminar el certificador "${certifier.name}"?`,
      header: 'Confirmar Eliminación',
      accept: async () => {
        await removeCertifier(certifier.id);
      }
    });
  };

  return (
    <div className="p-4">
      <Card title="Certificadores" className="shadow-2">
        {error && (
          <Message
            severity="error"
            text={`Error al cargar los certificadores: ${error}`}
            className="w-full mb-4"
          />
        )}

        <div className="mb-4">
          <Button
            label="Crear Certificador"
            icon="pi pi-plus"
            className="p-button-primary"
            onClick={openCreateModal}
          />
        </div>

        <DataTable
          value={certifiers}
          paginator
          rows={10}
          rowsPerPageOptions={[5, 10, 25]}
          tableStyle={{ minWidth: '50rem' }}
          emptyMessage="No se encontraron certificadores"
        >
          <Column field="id" header="ID" sortable style={{ width: '15%' }} />
          <Column field="name" header="Nombre" sortable style={{ width: '25%' }} />
          <Column field="description" header="Descripción" sortable style={{ width: '40%' }} />
          <Column
            header="Acciones"
            body={(rowData) => (
              <div className="flex gap-2">
                <Button
                  icon="pi pi-pencil"
                  className="p-button-text p-button-rounded"
                  onClick={() => openEditModal(rowData)}
                  tooltip="Editar"
                />
                <Button
                  icon="pi pi-trash"
                  className="p-button-text p-button-rounded p-button-danger"
                  onClick={() => handleDelete(rowData)}
                  tooltip="Eliminar"
                />
              </div>
            )}
            style={{ width: '20%' }}
          />
        </DataTable>
      </Card>

      <CertifierModal
        visible={modalVisible}
        onHide={closeModal}
        certifier={selectedCertifier}
        onSave={handleSave}
      />
      <ConfirmDialog />
    </div>
  );
};

export default CertifiersPage;